import { createAxiosInstance } from './http';
import { getCategoryLabel } from '../utils/categoryDisplay';

const normalizeSite = (site) => {
  const cat = site.category;
  return {
    ...site,
    id: site.id || site._id,
    _id: site._id || site.id,
    tags: Array.isArray(site.tags) ? site.tags : [],
    categoryName: getCategoryLabel(cat),
    categorySlug:
      cat && typeof cat === 'object' && cat.slug
        ? cat.slug
        : typeof cat === 'string'
          ? cat
          : '',
  };
};

const normalizeSitesResponse = (response) => {
  const data = response.data || response;
  const items = Array.isArray(data) ? data : [];
  return {
    data: items.map(normalizeSite),
    pagination: response.pagination || {},
  };
};

export const getSites = async (params = {}) => {
  const res = await createAxiosInstance().get('/sites', { params });
  return normalizeSitesResponse(res.data);
};

export const getTopSites = async (params = {}) => {
  const res = await createAxiosInstance().get('/sites/top', { params });
  const data = res.data.data || res.data;
  return Array.isArray(data) ? data.map(normalizeSite) : [];
};

export const getCategories = async () => {
  const res = await createAxiosInstance().get('/sites/categories');
  return res.data.data || res.data || [];
};

export const getSiteByDomain = async (domain) => {
  const res = await createAxiosInstance().get(`/sites/${encodeURIComponent(domain)}`);
  return normalizeSite(res.data.data || res.data);
};

export const getReviewsByDomain = async (domain, params = {}) => {
  const res = await createAxiosInstance().get(`/sites/${encodeURIComponent(domain)}/reviews`, { params });
  const data = res.data.data || res.data;
  return {
    data: (Array.isArray(data) ? data : []).map((item) => ({
      ...item,
      id: item.id || item._id,
      _id: item._id || item.id,
      author: item.authorName || item.author,
      date: item.date || item.createdAt,
    })),
    pagination: res.data.pagination || {},
  };
};

export const getSponsoredByDomain = async (domain) => {
  const res = await createAxiosInstance().get(`/sites/${encodeURIComponent(domain)}/sponsored`);
  const data = res.data.data || res.data;
  return (Array.isArray(data) ? data : []).map((item) => ({
    ...item,
    id: item.id || item._id,
    _id: item._id || item.id,
  }));
};

export const createReview = async (domain, data, token) => {
  const res = await createAxiosInstance(token).post(`/sites/${encodeURIComponent(domain)}/reviews`, data);
  return res.data;
};

export const getSimilarSites = async (domain) => {
  const res = await createAxiosInstance().get(`/sites/${encodeURIComponent(domain)}/similar`);
  const data = res.data.data || res.data;
  return (Array.isArray(data) ? data : []).map((s) => ({ ...normalizeSite(s), similarityVoteStats: s.similarityVoteStats }));
};

export const submitSimilarityVote = async (mainDomain, { alternativeDomain, rating, reason }) => {
  const res = await createAxiosInstance().post(`/sites/${encodeURIComponent(mainDomain)}/similarity-vote`, {
    alternativeDomain,
    rating,
    reason: reason || undefined,
  });
  return res.data;
};

